var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDottedCapLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 272,
    viewBox: "0 0 250 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_1484_7398)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 2,
    width: 90,
    height: 90,
    rx: 10,
    fill: "#F2B8EC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.77 60C129.827 60 130.683 59.1435 130.683 58.0869V48.2276C130.683 43.6803 126.997 39.9939 122.449 39.9939C117.902 39.9939 114.216 43.6803 114.216 48.2276V58.0822C114.216 59.1414 115.074 60 116.134 60H116.865C117.52 60 118.051 59.4686 118.051 58.8131C118.051 57.3207 119.221 56.1043 120.637 56.1043H124.261C125.679 56.1043 126.857 57.3207 126.857 58.8131C126.857 59.4686 127.388 60 128.044 60H128.77ZM118.763 52.8478C118.763 52.954 118.744 53.0644 118.705 53.1624C118.667 53.2604 118.613 53.351 118.542 53.4263C118.471 53.5013 118.385 53.5581 118.292 53.5987C118.199 53.6393 118.095 53.6594 117.994 53.6594H116.177C116.076 53.6594 115.972 53.6393 115.879 53.5987C115.786 53.5581 115.7 53.5013 115.629 53.4263C115.558 53.3513 115.504 53.2608 115.466 53.1624C115.427 53.0644 115.408 52.9543 115.408 52.8478V50.9506C115.408 50.8445 115.427 50.7344 115.466 50.636C115.504 50.538 115.558 50.4474 115.629 50.3721C115.7 50.2971 115.786 50.2403 115.879 50.1997C115.972 50.1591 116.076 50.1387 116.177 50.1387H117.994C118.094 50.1387 118.199 50.1588 118.292 50.1997C118.385 50.2403 118.47 50.2971 118.542 50.3721C118.613 50.4474 118.667 50.5377 118.705 50.636C118.744 50.7341 118.763 50.8441 118.763 50.9506V52.8478ZM118.763 47.2374C118.763 47.3435 118.744 47.4536 118.705 47.5519C118.667 47.65 118.613 47.7406 118.542 47.8155C118.471 47.8909 118.385 47.9473 118.292 47.9879C118.199 48.0285 118.095 48.049 117.994 48.049H116.177C116.076 48.049 115.972 48.0288 115.879 47.9879C115.786 47.9473 115.7 47.8905 115.629 47.8155C115.558 47.7406 115.504 47.65 115.466 47.5519C115.427 47.4539 115.408 47.3435 115.408 47.2374V45.3301C115.408 45.2239 115.427 45.1239 115.466 45.0256C115.504 44.9275 115.558 44.837 115.629 44.7616C115.7 44.6866 115.786 44.6198 115.879 44.5789C115.972 44.5383 116.076 44.5178 116.177 44.5178H117.994C118.094 44.5178 118.199 44.538 118.292 44.5789C118.385 44.6194 118.47 44.6863 118.542 44.7616C118.613 44.8366 118.667 44.9272 118.705 45.0256C118.744 45.1236 118.763 45.2236 118.763 45.3301V47.2374ZM120.772 45.2389C120.772 45.1327 120.791 45.0226 120.83 44.9243C120.868 44.8262 120.922 44.7357 120.993 44.6603C121.065 44.5854 121.15 44.5285 121.243 44.488C121.336 44.4474 121.441 44.4273 121.541 44.4273H123.166C123.266 44.4273 123.371 44.4474 123.464 44.488C123.557 44.5285 123.643 44.5854 123.714 44.6603C123.785 44.7353 123.839 44.8259 123.877 44.9243C123.916 45.0223 123.935 45.1324 123.935 45.2389V46.9432C123.935 47.0494 123.916 47.1494 123.877 47.2474C123.839 47.3455 123.785 47.436 123.714 47.5114C123.643 47.5863 123.557 47.6532 123.464 47.6938C123.371 47.7344 123.266 47.7548 123.166 47.7548H121.541C121.441 47.7548 121.336 47.7347 121.243 47.6938C121.15 47.6532 121.065 47.5863 120.993 47.5114C120.922 47.4364 120.868 47.3458 120.83 47.2474C120.791 47.1494 120.772 47.0494 120.772 46.9432V45.2389ZM123.983 52.6043C123.983 52.7105 123.964 52.8105 123.925 52.9088C123.886 53.0069 123.832 53.0975 123.761 53.1725C123.69 53.2478 123.605 53.3143 123.512 53.3552C123.418 53.3958 123.314 53.4159 123.214 53.4159H121.541C121.44 53.4159 121.336 53.3958 121.243 53.3552C121.15 53.3147 121.064 53.2478 120.993 53.1725C120.922 53.0975 120.868 53.0069 120.829 52.9088C120.791 52.8108 120.771 52.7108 120.771 52.6043V50.8493C120.771 50.7432 120.79 50.6331 120.829 50.5347C120.868 50.4367 120.922 50.3461 120.993 50.2711C121.064 50.1961 121.149 50.1393 121.243 50.0987C121.336 50.0582 121.44 50.0377 121.541 50.0377H123.214C123.314 50.0377 123.418 50.0578 123.512 50.0987C123.605 50.1393 123.69 50.1961 123.761 50.2711C123.833 50.3461 123.886 50.4367 123.925 50.5347C123.963 50.6331 123.983 50.7432 123.983 50.8493V52.6043ZM126.136 45.3301C126.136 45.2239 126.155 45.1239 126.194 45.0256C126.232 44.9275 126.286 44.837 126.357 44.7616C126.428 44.6866 126.514 44.6198 126.607 44.5789C126.7 44.5383 126.804 44.5178 126.905 44.5178H128.722C128.822 44.5178 128.927 44.538 129.02 44.5789C129.113 44.6194 129.198 44.6863 129.27 44.7616C129.341 44.8366 129.395 44.9272 129.433 45.0256C129.472 45.1236 129.491 45.2236 129.491 45.3301V47.2374C129.491 47.3435 129.472 47.4536 129.433 47.5519C129.395 47.65 129.341 47.7406 129.27 47.8155C129.199 47.8909 129.113 47.9473 129.02 47.9879C128.927 48.0285 128.822 48.049 128.722 48.049H126.905C126.804 48.049 126.7 48.0288 126.607 47.9879C126.514 47.9473 126.428 47.8905 126.357 47.8155C126.286 47.7406 126.232 47.65 126.194 47.5519C126.155 47.4539 126.136 47.3435 126.136 47.2374V45.3301ZM126.607 53.5984C126.514 53.5578 126.428 53.501 126.357 53.426C126.286 53.351 126.232 53.2604 126.194 53.1621C126.156 53.064 126.136 52.954 126.136 52.8475V50.9506C126.136 50.8445 126.155 50.7344 126.194 50.636C126.232 50.538 126.286 50.4474 126.357 50.3721C126.428 50.2971 126.514 50.2403 126.607 50.1997C126.7 50.1591 126.805 50.1387 126.905 50.1387H128.722C128.823 50.1387 128.927 50.1588 129.02 50.1997C129.113 50.2403 129.199 50.2971 129.27 50.3721C129.341 50.4474 129.395 50.5377 129.434 50.636C129.472 50.7341 129.491 50.8441 129.491 50.9506V52.8478C129.491 52.954 129.472 53.0644 129.434 53.1624C129.395 53.2604 129.341 53.351 129.27 53.4263C129.199 53.5013 129.113 53.5581 129.02 53.5987C128.927 53.6393 128.823 53.6594 128.722 53.6594H126.905C126.804 53.6594 126.7 53.639 126.607 53.5984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.596 37.8177C132.579 36.7351 131.811 35 130.348 35H119.042C118.566 35 118.112 35.2014 117.793 35.5543C116.813 36.6375 117.581 38.3698 119.042 38.3698H130.348C130.823 38.3698 131.276 38.1693 131.596 37.8177Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.221 54.9165C132.221 56.2804 133.901 56.9278 134.816 55.9165C135.064 55.6425 135.201 55.2861 135.201 54.9165V40.0516C135.201 38.689 133.524 38.0409 132.608 39.0496C132.359 39.3239 132.221 39.6811 132.221 40.0516V54.9165Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.636 57.7239C120.052 57.7239 119.587 58.2164 119.587 58.8147C119.587 59.4679 120.116 59.9974 120.769 59.9974H124.132C124.785 59.9974 125.315 59.4679 125.315 58.8147C125.315 58.2164 124.85 57.7239 124.262 57.7239H120.636Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_1484_7398",
    x: 0,
    y: 0.703704,
    width: 250,
    height: 271.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.85185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0168519 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1484_7398"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.14815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0274815 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1484_7398",
    result: "effect2_dropShadow_1484_7398"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1484_7398",
    result: "effect3_dropShadow_1484_7398"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38.5185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.7407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0425185 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1484_7398",
    result: "effect4_dropShadow_1484_7398"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 64.8148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4259
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0531481 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1484_7398",
    result: "effect5_dropShadow_1484_7398"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_1484_7398",
    result: "effect6_dropShadow_1484_7398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_1484_7398",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedCapLogo);
export default __webpack_public_path__ + "static/media/dotted-cap-logo.0fbc68e23cba20add1c49a43ac0f985e.svg";
export { ForwardRef as ReactComponent };